module.exports = __webpack_public_path__ + "static/media/wifi.bb59dd99.svg";